import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Sidebar from "./sidebar/Sidebar";

const Layout = () => {
  const location = useLocation();
  const path = location.pathname;

  const [isSidebarClose, setIsSidebarClose] = useState(false);
  const handleSidebarToogle = () => setIsSidebarClose(!isSidebarClose);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleSidebarOpen = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="layout-1">
      <Sidebar isSidebarClose={isSidebarClose} isSidebarOpen={isSidebarOpen} />
      <div className="wrapper">
        <Header
          isSidebarClose={isSidebarClose}
          isSidebarOpen={isSidebarOpen}
          handleSidebarToogle={handleSidebarToogle}
          handleSidebarOpen={handleSidebarOpen}
        />
        <Outlet />
        {path == "/app-email" ||
        path == "/app-chat" ||
        path == "/app-social" ||
        path == "/app-file-manager" ||
        path == "/app-project" ||
        path == "/app-project-detail" ||
        path == "/app-blog-detail" ||
        path == "/crm/app-blog" ||
        path == "/crm/app-project" ||
        path == "/app-tasks" ? (
          ""
        ) : (
          <Footer />
        )}
      </div>
    </div>
  );
};

export default Layout;
